<template>
  <div class="online-content">
    <div class="home-box">
      <router-link
        class="baby-info-box"
        tag="div"
        :to="{ path: '/MyCenter/mine' }"
      >
        <div class="img">
          <img
            v-if="$store.state.currentChild.student_img != ''"
            :src="$store.state.currentChild.student_img"
            alt
          />
          <img
            v-else-if="
              $store.state.currentChild.student_img == '' &&
                $store.state.currentChild.student_sex == $t('Common.woman')
            "
            src="@/assets/images/childWoman.png"
            alt
          />
          <img
            v-else-if="
              $store.state.currentChild.student_img == '' &&
                $store.state.currentChild.student_sex == $t('Common.man')
            "
            src="@/assets/images/childMan.png"
            alt
          />
          <img
            v-else-if="
              $store.state.currentChild.student_img == '' &&
                $store.state.currentChild.student_sex == ''
            "
            src="@/assets/images/childImg.png"
            alt
          />
          <!-- <img v-if="$store.state.currentChild.student_img !=''" :src="$store.state.currentChild.student_img" alt />
          <img v-else src="@/assets/images/childImg.png" alt />-->
        </div>
        <div class="info">
          <p class="one cursor">
            {{ $store.state.currentChild.student_cnname || $t("Home.noName") }}
            <!-- <em class="icon-bofang"></em> -->
          </p>
          <p class="two cursor">
            {{ $store.state.currentChild.school_cnname || $t("Home.noSchool") }}
          </p>
          <p class="two cursor" style="margin-top:5px">
            {{ $store.state.currentChild.class_cnname || $t("Home.noClass") }}
          </p>
        </div>
      </router-link>
      <div class="home-category">
        <div class="item" tag="div" @click="linkToTaskCenter()">
          <div class="img">
            <img src="../../assets/images/home/task.png" alt />
          </div>
          <p class="text" v-if="flagStudentType == 'school'">
            {{
              $store.state.globalTxt.homemenu1
                ? $store.state.globalTxt.homemenu1
                : $t("Header.task")
            }}
          </p>
          <p class="text" v-else-if="flagStudentType == 'kid'">
            {{
              $store.state.globalTxt.homemenu1
                ? $store.state.globalTxt.homemenu1
                : $t("Header.myTask")
            }}
          </p>
          <span v-if="$store.state.undonenums != 0" class="tips bg-base">{{
            $store.state.undonenums
          }}</span>
        </div>
        <router-link class="item" tag="div" :to="{ path: '/StudyCenter' }">
          <div class="img">
            <img src="../../assets/images/home/study.png" alt />
          </div>
          <p class="text">
            {{
              $store.state.globalTxt.homemenu2
                ? $store.state.globalTxt.homemenu2
                : $t("Header.studyCenter")
            }}
          </p>
          <!-- <span class="tips bg-base">15</span> -->
        </router-link>
      </div>
    </div>
    <div class="home-bottom">
      <img
        src="../../assets/images/home/bottom.png"
        alt
        v-if="$store.state.currentChild.class_genre == 'school'"
      />
      <img
        src="../../assets/images/home/bottom1.png"
        alt
        v-if="$store.state.currentChild.class_genre == 'kid'"
      />
    </div>
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="popTipsCont.dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>

<script>
import Api from "./indexApi.js";
import PopTips from "@/components/popTips";

export default {
  name: "home",
  data() {
    return {
      CLASS_NAME: "1",
      undonenums: 0,
      flagStudentType: "", // 少儿或者幼儿的标识
      popTipsCont: {
        dialogVisable: false,
        title: this.$t("Common.tips"),
        context: this.$t("Home.noData"),
        btns: [
          {
            text: this.$t("Common.confirm"),
            event: "handConfirm",
          },
        ],
      },
    };
  },
  components: { PopTips },
  created() {
    //園=我的任務；校=作業任務
    if (this.$store.state.currentChild.class_genre == "school") {
      //少儿-校
      this.flagStudentType = "school";
    } else if (this.$store.state.currentChild.class_genre == "kid") {
      //幼儿 - 园
      this.flagStudentType = "kid";
    }
    // console.log(this.$store.state.CLASS_NAME);
    // if (this.$store.state.CLASS_NAME == "1") {
    //   //少儿
    //   console.log(111);
    //   this.CLASS_NAME = "1";
    // } else if (this.$store.state.CLASS_NAME == "0") {
    //   //幼儿
    //   console.log(2222);
    //   this.CLASS_NAME = "0";
    // }
    this.getNodonums();
    // this.getOneStudent()
  },
  methods: {
    getOneStudent() {
      Api.getOneStudent({
        student_id: this.$store.state.currentChild.student_id,
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          const {
            student_autologoutTime,
            student_intervalremindTime,
          } = result.list;
          this.$Tool.setStorage("AUTO_LOGOUT_TIME", student_autologoutTime);
          this.$Tool.setStorage(
            "INTERVAL_REMIND_TIME",
            student_intervalremindTime
          );
        }
      });
    },
    linkToTaskCenter(v) {
      console.log(v);
      if (this.$store.state.has_num) {
        console.log("上面");
        this.$router.push({
          path: "/TaskCenter",
        });
      } else {
        console.log("下面");
        this.popTipsCont.dialogVisable = true;
      }
    },
    handleCloseTip() {
      this.popTipsCont.dialogVisable = false;
    },
    handConfirm() {
      console.log("ok");
      this.popTipsCont.dialogVisable = false;
    },
    getNodonums() {
      Api.getNodonums({
        student_id: this.$store.state.currentChild.student_id,
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
      }).then((res) => {
        console.log(res);
        const { list } = res.data.result;
        this.has_num = list.has_num;
        this.undonenums = list.undonenums;
        this.$Tool.setStorage("undonenums", this.undonenums);
        this.$store.dispatch("setundonenums", this.undonenums);
        this.$Tool.setStorage("has_num", this.has_num);
        this.$store.dispatch("sethas_num", this.has_num);
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import url("./home");
</style>
